export class ProductInfoResponseDto{
    product: string;
    cartons: number;
    constructor(product: string,cartons: number){
        this.product = product;
        this.cartons = cartons;
    }
}

